import { Pipe, PipeTransform } from '@angular/core';
import { formatDistance } from 'date-fns';

@Pipe({
  name: 'humanizeDate',
})
export class HumanizeDatePipe implements PipeTransform {
  transform(value): any {
    let dateTime;
    if ((value as string).indexOf('Z') < 0) {
      dateTime = new Date(value + 'Z');
    } else {
      dateTime = new Date(value);
    }
    const formattedDistance = formatDistance(dateTime, new Date(), {
      includeSeconds: true,
      addSuffix: true,
    });
    return this.customTextReplacing(formattedDistance);
  }

  customTextReplacing = (formattedDistance: string) => {
    let replacedText = this.replaceWording(formattedDistance);
    if (replacedText.indexOf('about') >= 0) {
      replacedText = replacedText.replace('about', '');
    }
    if (replacedText.indexOf('less than') >= 0) {
      replacedText = replacedText.replace('less than', '');
    }
    if (replacedText.indexOf('half') >= 0) {
      replacedText = replacedText.replace('half', '');
    }
    return replacedText;
  };

  replaceWording = (formattedDistance: string) => {
    if (
      formattedDistance.indexOf('minutes') ||
      formattedDistance.indexOf('minute')
    ) {
      return formattedDistance.replace('minute', 'min');
    }
    if (
      formattedDistance.indexOf('seconds') ||
      formattedDistance.indexOf('second')
    ) {
      return formattedDistance.replace('second', 'sec');
    }
    if (
      formattedDistance.indexOf('hours') ||
      formattedDistance.indexOf('hour')
    ) {
      return formattedDistance.replace('hour', 'hr');
    }
    if (
      formattedDistance.indexOf('years') ||
      formattedDistance.indexOf('year')
    ) {
      return formattedDistance.replace('year', 'yr');
    }
  };
}
